import styled from "styled-components";

export const Container = styled.div`
`

export const ModalAnswerType = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;

    .title {
        color: ${({ theme }) => theme.colors.interfacePure500};
        font-weight: 400;
        margin-top: 8px;

        span {
            font-weight: 600;
        }

    }

    .value {
        display: flex;
        align-items: center;   
        gap: 20px;
        width: 212px;
        height: 56px;
        background-color: ${({ theme }) => theme.colors.background};
        border-radius: 8px;
        padding: 8px;
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;        

        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background-color: ${({ theme }) => theme.colors.interfacePure0};
            border-radius: 8px;                      
        }
    }

    .justification {
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;  
    }

    .profit {
        color: ${({ theme }) => theme.colors.interfacePure500};
        font-weight: 400;  

        span {
            font-weight: 600;
        }
    }

    .values {
        display: flex;
        align-items: center;
        justify-content: space-between;


    }

    .bold {
        color: ${({ theme }) => theme.colors.interfacePure500};
        font-weight: 600;  
    }

    .old-price {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 212px;
            height: 56px;
            border-radius: 8px;
            background-color: ${({ theme }) => theme.colors.background};
            color: ${({ theme }) => theme.colors.interfaceText500};
            font-weight: 400;

            p {
                color: ${({ theme }) => theme.colors.interfaceText300};
            }

            .icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                border-radius: 8px;
                background-color: ${({ theme }) => theme.colors.interfacePure0};
            }
    }

    .new-price {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 212px;
        height: 56px;
        border-radius: 8px;
        background-color: ${({ theme }) => theme.colors.secondaryPool100};
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;
        
        p {
            color: ${({ theme }) => theme.colors.interfaceText300};
        }

        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 8px;
            background-color: ${({ theme }) => theme.colors.interfacePure0};
        
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.secondaryPool200};
                }
            }
        }

    }

    .request {
        color: ${({ theme }) => theme.colors.interfacePure500};
        font-weight: 500;
    }

    .file {
        display: flex;
        gap: 8px;
        height: 56px;
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;

        .file-details{
            display: flex;
            justify-content: space-between;
            width: 100%;
            border: 2px solid ${({ theme }) => theme.colors.interfacePure100};
            border-radius: 8px;
            padding: 16px;

            &.highlight {
                background-color: ${({ theme }) => theme.colors.secondaryPool100};
            }

            .icon-title {
                display: flex;
                align-items: center;
                gap: 18px;
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.interfaceGray400};

                .icon-file {
                    width: 20px;
                    height: 20px;
                }

                .title-file {
                    max-width: 350px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        .icon-trash {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            cursor: pointer;
            svg {
                width: 24px;
                height: 24px;
                path {
                    fill: ${({ theme }) => theme.colors.primaryBlue500};
                }
            }
        }

        .download {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            border-radius: 8px;
            cursor: pointer;
            transition: all .3s;
            &:hover {
                background-color: ${({ theme }) => theme.colors.interfaceText100};
            }
        }
    }

    .add {
        display: flex;
        align-items: center;
        gap: 20px;
        height: 56px;
        padding: 16px;
        border: 2px dotted ${({ theme }) => theme.colors.primaryRed400};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        font-weight: 500;
        cursor: pointer;
        position: relative;
        svg {
            path {
                fill: ${({ theme }) => theme.colors.primaryRed400};
            }
        }

        .file-input {
            width: 100%;
            height: 100%;
            color: transparent;
            transition: all .5s;
            border: none;
            padding: 0;
            background: transparent;
            border-radius: 8px;
            position: absolute;
            top: 0;
            left: 0;
        }
        .file-input::-webkit-file-upload-button {
            visibility: hidden;
        }
        .file-input::before {
            content: 'Anexar arquivos';
            color: ${({ theme }) => theme.colors.interfaceGray400};
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border: none;
            padding: 0;
            width: 100%;
            height: 50px;
            outline: none;
            white-space: nowrap;
            -webkit-user-select: none;
            user-select: none;
            cursor: pointer;
            font-weight: 500;
            font-size: 18px;
            padding-left: 60px;
        }
        .file-input:active {
            outline: 0;
        }

        .file-input:disabled {
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    .loading-file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: ${(props: any) => props.theme.colors.white};
        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
        border-radius: 8px;
        padding: 12px 16px;
        height: 48px;
        box-sizing: border-box;
        margin-top: 8px;
        position: relative;
        overflow: hidden;
    }

    .loading-file-info {
        display: flex;
        gap: 12px;
        align-items: center;
        flex: 1;
    }

    .loading-file-name {
        color: ${(props: any) => props.theme.colors.c1a202c};
        font-size: 14px;
        font-weight: 400;
        animation: pulse 1.5s ease-in-out infinite;
    }

    .loading-file-size {
        color: ${(props: any) => props.theme.colors.c6b7280};
        font-size: 12px;
        animation: pulse 1.5s ease-in-out infinite;
    }

    .loading-spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        flex-shrink: 0;
    }

    .spinner {
        width: 16px;
        height: 16px;
        border: 2px solid ${(props: any) => props.theme.colors.ce2e8f0};
        border-top: 2px solid ${(props: any) => props.theme.colors.primaryRed400};
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes pulse {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }

    .text {
        width: 100%;
        height: 160px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
        border-radius: 8px;
        margin-top: 8px;
        padding: 16px;

        &.money {
            height: 80px;
        }

        .text-area {
            width: 100%;
            height: 100%;
            border: none;
            border-radius: 8px;
            resize: none;
            color: ${({ theme }) => theme.colors.interfacePure500};
            font-weight: 500;
            outline: none;
            font-family: Montserrat, sans-serif;
            font-size: 16px;
            line-height: 24px;    
            
            &.highlight {
                background-color: ${({ theme }) => theme.colors.secondaryPool100};
            }
        }
    }

    .info-description {
        font-size: 16px;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.interfaceText400};
        margin-bottom: -16px;
    }
`

export const ModalButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    justify-content: space-between;
    width: 100%;

    .continue {
        background: ${({ theme }) => theme.colors.primaryRed400};

        span {
            color: ${({ theme }) => theme.colors.interfacePure0};
        }
    }

    .danger {
        background: ${({ theme }) => theme.colors.primaryRed400};
    }
`

export const ModalContent = styled.div`
    padding: 0 24px;
    width: 100%;
`